


function linkOptions(scope, attrs, ModelConfig, BasicOptions, StateList) {
    var expression;

    if (angular.isDefined(BasicOptions[attrs.options])) {
        scope.options = BasicOptions[attrs.options];
    } else if (attrs.options === 'states') {
        StateList().then(function(states) {scope.options = states; });
    } else if (attrs.options) {
        scope.$parent.$watch(attrs.options, function(options) {
            scope.options = options;
        });
    } else {
        scope.options = ModelConfig.getOptions(attrs.name);
    }
}

function linkNgModel(scope, ngModel) {
    scope.data = {value: undefined};

    ngModel.$render = function() {
        scope.data.value = ngModel.$viewValue;
    };

    scope.change = function(value) {
        ngModel.$setViewValue(value);
        ngModel.$render();
    };
}

module.directive('optionRadios', function(ModelConfig, BasicOptions, StateList) {
    return {
        restrict: 'E',
        templateUrl: 'util/input/optionRadios',
        require: 'ngModel',
        scope: {},
        link: function(scope, element, attrs, ngModel) {
            linkOptions(scope, attrs, ModelConfig, BasicOptions, StateList);
            linkNgModel(scope, ngModel);
        }
    };
});

module.directive('optionSelect', function($timeout, ModelConfig, BasicOptions, Page, StateList) {
    return {
        restrict: 'E',
        templateUrl: 'util/input/optionSelect',
        require: ['ngModel', '?formField'],
        scope: {noSearch: '@', disabledOptions: '='},
        link: function(scope, element, attrs, controllers) {
            console.log(scope.disabledOptions);
            linkOptions(scope, attrs, ModelConfig, BasicOptions, StateList);
            linkNgModel(scope, controllers[0]);
        }
    };
});
